/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceBulkActionLeadResult } from './InstanceBulkActionLeadResult';
import {
    InstanceBulkActionLeadResultFromJSON,
    InstanceBulkActionLeadResultFromJSONTyped,
    InstanceBulkActionLeadResultToJSON,
} from './InstanceBulkActionLeadResult';

/**
 * 
 * @export
 * @interface InstanceBulkActionResult
 */
export interface InstanceBulkActionResult {
    /**
     * 
     * @type {Array<InstanceBulkActionLeadResult>}
     * @memberof InstanceBulkActionResult
     */
    results: Array<InstanceBulkActionLeadResult>;
}

/**
 * Check if a given object implements the InstanceBulkActionResult interface.
 */
export function instanceOfInstanceBulkActionResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function InstanceBulkActionResultFromJSON(json: any): InstanceBulkActionResult {
    return InstanceBulkActionResultFromJSONTyped(json, false);
}

export function InstanceBulkActionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkActionResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(InstanceBulkActionLeadResultFromJSON)),
    };
}

export function InstanceBulkActionResultToJSON(value?: InstanceBulkActionResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': ((value.results as Array<any>).map(InstanceBulkActionLeadResultToJSON)),
    };
}

